export default class Nav {
  constructor() {
    var isNavOut = false; // Initialize a flag to track the visibility state of the nav

    this.hide();
    window.addEventListener("resize", this.hide);

    $(window).on("scroll", function () {
      var nav = $("#nav"); // Select the nav element
      var navFixed = $("#nav--fixed"); // Select the nav--fixed element
      var navTop = nav.offset().top; // Get the offset top position of the nav
      var navHeight = nav.outerHeight(); // Get the height of the nav element
      var windowTop = $(window).scrollTop(); // Get the scroll position of the window

      // Check if the nav is scrolled out of the viewport
      if (windowTop > navTop + navHeight) {
        if (!isNavOut) {
          // Only run if the nav was previously in view
          // $(navFixed).removeClass("hidden");
          $(navFixed).css("top", 0);
          isNavOut = true; // Update the flag to indicate the nav is out of view
        }
      } else {
        if (isNavOut) {
          // Only run if the nav was previously out of view
          // $(navFixed).addClass("hidden");
          $(navFixed).css("top", -navHeight);
          isNavOut = false; // Update the flag to indicate the nav is back in view
        }
      }
    });

    const mobileNav = $("#nav--mobile");
    const mobileNavOpenButton = $(".open-btn");
    const mobileNavCloseButton = $(".close-btn");

    $(mobileNavOpenButton).on("click", () => {
      $(mobileNav).removeClass("hidden");
    });
    $(mobileNavCloseButton).on("click", () => {
      $(mobileNav).addClass("hidden");
    });
  }

  hide() {
    var nav = $("#nav"); // Select the nav element
    var navFixed = $("#nav--fixed"); // Select the nav--fixed element
    var navHeight = nav.outerHeight(); // Get the height of the nav element
    $(navFixed).css("top", -navHeight);

    const banner = $(".banner");
    $(banner).css("margin-top", -navHeight);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/nav.js